import React from 'react'
import { Widget, Action, mk_widget, nothing } from 'widgets-for-react'
import { HeaderState, OptionsState } from '../../public_site.main.mod'
import { t } from 'i18next'
import { SearchBar } from './searchbar'
import { Link } from 'react-router-dom'
import { lang, availableLanguages } from '../application.mod'
import MainNavItems from './nav_items_main'
import { state } from '../../portal/login'
import { WordPress } from '../../wordpress/wordpress_api'
import { toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import MobileNavItems from './nav_items_mobile'

export const header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>> = (
  props,
  opts
) =>
  mk_widget({
    run: setState => {
      return (
        <Header
          className="header"
          onMouseLeave={_ => setState(s => ({...s, hoveredItem: null}))}
        >
          <div className="header__inner container--m">
            <div className="header__logo">
              <Link to={window.wp.language == 'nl' ? "/" : "/en" }>
                <img className="header__image" src="/frontend/images/logo.svg" alt="Dubbeldam logo" />
              </Link>
            </div>
            <nav className="header__nav nav nav--main typo--2xs">
              <MainNavItems
                cssClass="desktop"
                location="main"
                hasActiveState={true}
                hoveredItem={props.hoveredItem}
                onHoverItem={item => setState(s => ({...s, hoveredItem: item}))}
                onUnhoverItem={() => setState(s => ({...s, hoveredItem: null}))}
              />
              <MobileNavItems
                cssClass="mobile"
                location="main"
                hasActiveState={true}
              />
            </nav>
            <ul className="header__list">
              <li className="header__item">
                <button
                  className="header__button search"
                  onClick={_ => {
                    setState(s => ({
                      ...s,
                      showSearchBar: !props.showSearchBar
                    }));
                    !props.showSearchBar
                      ? document.body.classList.add("noscroll")
                      : document.body.classList.remove("noscroll");
                  }}
                >
                  <svg className="search__icon" width="18px" height="16px">
                    <use xlinkHref="#icon--search" />
                  </svg>
                </button>
              </li>
              <li className="header__item">
                <button
                  className="header__toggler toggler"
                  onClick={_ => setState(s => ({...s, menu: props.menu == "open" ? "closed" : "open"}))}
                  aria-controls="a11y-menu"
                  aria-expanded={props.menu == "open" ? true : false}
                >
                  <span className="sr-text">Toggle Menu</span>
                  <span className="toggler__line toggler__line--close" />
                  <span className="toggler__line toggler__line--close" />
                  <span className="toggler__line" />
                </button>
              </li>
            </ul>
            <SearchBar
              show={props.showSearchBar}
              hide={() => {
                setState(s => ({...s, showSearchBar: false}));
              }}
              searchValue={props.searchValue}
              updateSearchValue={newValue => setState(s => ({...s, searchValue: newValue}))}
            />
          </div>

          {props.hoveredItem &&  props.hoveredItem.children.length > 0 && (
            <div className="header__flyout flyout flyout--open">
              <div className="flyout__inner">
                <nav className="nav nav--submenu">
                  <ul className="nav__list">
                    {props.hoveredItem.children.length > 0 ? (
                      <>
                        {props.hoveredItem.children.map((menuChild: WordPress.MenuItem) => (
                          <li className="nav__item  typo--2xs" key={`main-child-${menuChild.ID}`}>
                            <Link to={toRelativeUrl(menuChild.url)} className="nav__link nav__link--sub">
                              {decodeHTMLEntities(menuChild.title)}
                            </Link>
                          </li>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                </nav>
              </div>
            </div>
          )}


        </Header>
      );
    }
  })

type HeaderComponentState = {
  // sticky: boolean
  // shown: boolean
}

type HeaderComponentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {

}

class Header extends React.Component<HeaderComponentProps, HeaderComponentState> {
  // private raf: number
  private headerRef: HTMLElement
  // private headerHeight: number = 0
  // private scrollStartTime: number = 0
  // private scrollStartY: number = 0

  constructor(props) {
    super(props)

    this.state = {
      // sticky: false,
      // shown: false
    };

    // this.updateScrollState = this.updateScrollState.bind(this)
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
  }

  componentWillUnmount() {
    // window.cancelAnimationFrame(this.raf)
  }

  updateScrollState(t: number) {
    // this.raf = window.requestAnimationFrame(this.updateScrollState)
    // this.headerHeight = this.headerRef.clientHeight

    // if (window.pageYOffset < (this.headerHeight / 2)) {
    //   this.setState({
    //     ...this.state,
    //     sticky: false,
    //     shown: true
    //   })
    //   return
    // }

    // if (
    //   this.scrollStartTime > 0 &&
    //   t - this.scrollStartTime < 100 &&
    //   this.scrollStartY - window.pageYOffset > 10
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: true
    //   })
    //   return
    // } else if (
    //   this.scrollStartY - window.pageYOffset < 0 &&
    //   this.props.mobileMenu != "open"
    // ) {
    //   this.setState({
    //     ...this.state,
    //     shown: false
    //   })
    // }

    // this.scrollStartY = window.pageYOffset
    // this.scrollStartTime = t

    // if (window.pageYOffset > this.headerHeight) {
    //   if (!this.state.sticky) {
    //     this.setState({
    //       ...this.state,
    //       sticky: true
    //     })
    //   }
    // } else {
    //   this.setState({
    //     ...this.state,
    //     sticky: false
    //   })
    // }
  }

  render() {
    return (
      // ${
      //   this.state.sticky ? " header--stucky" : ""
      // }${this.state.shown ? " header--showny" : ""}${
      //   this.props.mobileMenu == "open" ? " header--full-menu" : ""
       // }
        <header ref={ref => (this.headerRef = ref)} {...this.props}></header>
    )
  }
}
